import styles from "./index.module.css";
import clsx from "clsx";
import { createResponsiveClassNames } from "../../../lib/utils";

export const Grid = ({
  children, 
  className, 
  gap = 'medium' 
}) => (
  <div className={clsx(
    styles.grid, 
    gap === 'small' && styles.gapSmall, 
    gap === 'medium' && styles.gapMedium, 
    gap === 'large' && styles.gapLarge, 
    className
  )}>
    {children}
  </div>
);

export const Column = ({
  children,
  className,
  span,
}) => (
  <div className={clsx(
    styles.column,
    createResponsiveClassNames(styles, 'span', span),
    className
  )}>
    {children}
  </div>
);